export type FileKind = 'pdf' | 'image' | 'other';

export function getFileKindFromUrl(url: string | undefined | null): FileKind {
  const raw = (url || '').trim();
  const u = raw.toLowerCase();
  if (!u) return 'other';

  if (u.startsWith('data:')) {
    if (u.includes('application/pdf') || u.includes('/pdf')) return 'pdf';
    if (u.startsWith('data:image/')) return 'image';
    return 'other';
  }

  // Strip query/hash
  const clean = u.split('#')[0].split('?')[0];
  const ext = clean.split('.').pop() || '';

  if (ext === 'pdf') return 'pdf';
  if (['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'svg'].includes(ext)) return 'image';
  return 'other';
}

